import { render, staticRenderFns } from "./applyOpportunity.vue?vue&type=template&id=4b693878"
import script from "./applyOpportunity.vue?vue&type=script&lang=ts"
export * from "./applyOpportunity.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports